import { Injectable } from '@angular/core';
import { Role } from '../api/role';
import { HttpErrorResponse } from '@angular/common/http';
import { OnFinish } from '../../api/api/on-finish';
import { RokezzzApiService } from '../../api/services/api.service';

@Injectable({
    providedIn: 'root'
})
export class RokezzzRoleService {
    private readonly apiPath: string = 'roles';

    public constructor(
        private readonly rokezzzApiService: RokezzzApiService
    ) { }

    public getIRI(uuid: string): string {
        return this.rokezzzApiService.apiUrl + this.apiPath + '/' + uuid;
    }

    public getCollectionForUser(
        onSuccess: OnFinish<Role[]>,
        onError: OnFinish<HttpErrorResponse>
    ): void {
        this.rokezzzApiService.get(
            this.apiPath + '/loggedUser',
            {},
            onSuccess,
            onError
        );
    }
}
